"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteeIdentifierType = void 0;
var InviteeIdentifierType;
(function (InviteeIdentifierType) {
    InviteeIdentifierType["Email"] = "email";
    InviteeIdentifierType["Hash"] = "hash";
    InviteeIdentifierType["Uuid"] = "uuid";
})(InviteeIdentifierType || (exports.InviteeIdentifierType = InviteeIdentifierType = {}));
